import { BASE_FORMS_TEMPLATES_ROUTE } from './form-templates.constants';
import {
  getFormTemplatesListRoute,
  getFormTemplateDetailsRoute,
  getFormTemplateDetailsV2Route,
} from './form-templates.utils';

export const FORM_TEMPLATES_ROUTES = {
  base: BASE_FORMS_TEMPLATES_ROUTE,
  templatesList: getFormTemplatesListRoute,
  /**
   * @deprecated
   */
  templateDetails: getFormTemplateDetailsRoute,
  templateDetailsV2: getFormTemplateDetailsV2Route,
};
